import { reverse } from 'named-urls'

import { routing } from '@utils/routing'

export const getShippingGroupLink = (id?: string) => {
  const searchParams = new URLSearchParams(location.search)
  searchParams.set('selfFulfilled', '1')
  const pathname = id
    ? reverse(routing.settings.shipping.group.self, { shippingGroupId: id })
    : routing.settings.shipping.group.create

  return {
    pathname,
    search: searchParams.toString(),
  }
}
